























































































































































































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { UserService } from "@/modules/partners/services/user.service";
import { SkillService } from "@/modules/partners/services/skill.service";
import { User, Skill } from "@/modules/core/models";
import _ from "lodash";
import {Debounce} from "@/modules/core/utils/decorators"

@Component
export default class Register extends Vue {
  @Prop({ default: "default value", required: true, type: [Boolean, String] })
  cannot_cancel_registration: Boolean | String;

  @Watch('form.skills.search')
  @Debounce(300)
  async onSeachSkillsChanged(val: string, oldVal: string) {

    this.form.skills.loading = true
    // do call to api to get skills
    let list_skills: Array<Skill> = await SkillService.list(1, 10, {search:val});
    let aux: Array<string> = _.map(list_skills, (skill:Skill) => {return skill.name});
    this.form.skills.items = aux;

    this.form.skills.loading = false
  }

  form = {
    email: "",
    email_rules: [
      (v: any) => !!v || "el email es obligatorio",
      (v: any) => /.+@.+/.test(v) || "El email debe ser valido"
    ],
    password: "",
    promo_code: "",
    promo_rule: [
      (v:string) => [""].includes(v) || "Este codigo promocional no es valido"
    ],
    valid_1: false as boolean,

    name: "",
    surname: "",
    ubication: "",
    profesion: "",
    hours_of_work: 5,
    skills: {
      items: [{ header: "Escribir tus habilidades" },] as Array<any>,
      search: null,
      select_skills: [] as Array<string>,
      loading: false
    },
    experience_in_startups: false as boolean,
    has_project: false as boolean,
    cv_url: "",
    valid_2: false as boolean
  };

  display_navigation: boolean = true;
  profesional_categories = [
    "Programación",
    "Diseño",
    "Comunicación y Marketing",
    "Negocios"
  ];

  ubicaciones = ["A Coruña", "Álava","Albacete","Alicante","Almería","Asturias","Ávila","Badajoz","Baleares","Barcelona","Burgos","Cáceres","Cádiz","Cantabria","Castellón","Ciudad Real","Córdoba","Cuenca","Girona","Granada","Guadalajara","Gipuzkoa","Huelva","Huesca","Jaén","La Rioja","Las Palmas","León","Lérida","Lugo","Madrid","Málaga","Murcia","Navarra","Ourense","Palencia","Pontevedra","Salamanca","Segovia","Sevilla","Soria","Tarragona","Santa Cruz de Tenerife","Teruel","Toledo","Valencia","Valladolid","Vizcaya","Zamora","Zaragoza"];
  search = null;
  step: number = 1;
  show_password = false;
  rules = {
    required: (v: any) => !!v || "Obligatorio.",
    required_list: (v: any) => v.length > 0 || "Obligatorio.",
    min: (v: any) => v.length >= 8 || "Min 8 caracteres",
    linkedin_url: (v: any) =>
      v.length > 0
        ? /((https?:\/\/)?((www|\w\w)\.)?linkedin\.com\/).*$/.test(
            v
          ) || "La url de linkedin no es valida"
        : true,
  };

  get currentTitle() {
    switch (this.step) {
      case 1:
        return "Sign-up";
      case 2:
        return "Create a password";
      default:
        return "Account created";
    }
  }

  get can_next() {
    switch (this.step) {
      case 1:
        return this.form.valid_1;
      case 2:
        return this.form.valid_2;
      default:
        return false;
    }
  }

  next(): void {
    this.step++;
    if (this.step === 3) {
      this.display_navigation = false;

      // create user api
      // add auth token
      // store.commit("userLogIn")
    }
  }

  step_back(): void {
    this.step--;
    if (this.step === 0) {
      this.$emit("registration_canceled");
    }
  }

  finish(): void {
    this.create_user();
    this.$emit("registration_finished");
    this.reset();
  }

  reset(): void {
    this.step = 1;
    this.display_navigation = true;
  }

  create_user(): void {
    let skills: Array<Skill> = [];
    for (let skill of this.form.skills.select_skills) {
      skills.push(new Skill(skill));
    }

    let user: User = new User(
      this.form.email,
      this.form.name,
      this.form.ubication,
      this.form.profesion,
      skills,
      this.form.surname,
      undefined,
      this.form.password,
      this.form.hours_of_work,
      this.form.experience_in_startups,
      this.form.has_project,
      this.form.cv_url,
      undefined,
      this.form.promo_code
    );

    UserService.create(user);
  }


}
